import not_img from './img/not_img.svg'
import trash_icon from './img/trash_icon.svg'
import { useEffect } from 'react';
import "./CardVariantProduct.scss"
import { ButtonWithIcon } from '../../Buttons/ButtonWithIcon/ButtonWithIcon';

const CardVariantProduct = ({ ...props }) => {
    const {
        product_id,
        name,
        offer_id,
        deleteProduct,
        setCurrentProductId,
        currentProductId,
        setIsGeneralloading,
        setProductTemporary,
        productTemporaryList,
        ind,
        currentProduct,
        setCurrentProduct,
        setProductTemporaryList,
        deleteLastProject,
        img = []
    } = props

    useEffect(() => {
        setProductTemporary(productTemporaryList?.[currentProduct])
    }, [currentProduct]);


    return (
        <div className='card-variant-product'
            style={currentProduct === ind ? { border: '1px solid #3900B1' } : {}}
            onClick={e => {
                setCurrentProduct(ind)
                setProductTemporary(productTemporaryList[ind])
            }}
        >
            <div className='card-variant-product__img-box'>
                <img className={img?.[0] ? 'img' : 'not_img'} src={img?.[0] ? img?.[0] : not_img} />
            </div>
            <div className='card-variant-product__content'>
                <p className='text_article'>
                    {offer_id ? offer_id : 'Не указано'}
                </p>
                <h5 className='title_product'>
                    {name ? name : 'Нет названия'}
                </h5>
            </div>

            <ButtonWithIcon
                size='xs'
                lilac
                icon={trash_icon}
                onClick={e => {
                    e.stopPropagation()
                    const curr = productTemporaryList.filter((el, index) => ind != index)
                    setProductTemporaryList(curr)
                    setCurrentProduct(0)
                    if (productTemporaryList?.length === 1) {
                        deleteLastProject()
                    }
                }}
            />

        </div>
    )
}

export { CardVariantProduct }